import { render, staticRenderFns } from "./HorizontalNavigation.vue?vue&type=template&id=4ccdfd1f&scoped=true&"
import script from "./HorizontalNavigation.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavigation.vue?vue&type=style&index=0&id=4ccdfd1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdfd1f",
  null
  
)

export default component.exports